import { LoadingButton } from "@mui/lab"
import { Box, Button } from "@mui/material"
import i18n from "i18n-js"
import { InputForm } from "../../../components"
import BaseModal from "../../../components/baseModal"
import { useStyles } from "./styles"

export const StatisticReport = ({ open, handleClose, handleOpen, access, handleChange, inputs, data, handleSave, disabled = false, loading = false }) => {
    if (!access) { return null }

    const { styles } = useStyles()
    return (
        <Box sx={styles.container}>
            <Button onClick={handleOpen} sx={styles.btn} variant="contained">{i18n.t("general.report")}</Button>

            <BaseModal
                open={open}
                onClose={handleClose}
                title={i18n.t("general.statisticalSummaryReport")}
                footer={(
                    <Box sx={styles.footer}>
                        <Button onClick={handleClose} variant="outlined"> {i18n.t('components.cancel')}</Button>

                        <LoadingButton loading={loading} disabled={disabled} onClick={handleSave} variant="contained">{i18n.t('components.Generate')}</LoadingButton>
                    </Box>
                )}
            >
                <Box sx={styles.content}>
                    <Box sx={styles.inputContainer}>
                        <InputForm
                            color="secondary"
                            clear
                            onChange={() => { }}
                            onAccept={(value) => {
                                if (value !== null && value !== data.start) {
                                    handleChange({ target: { value: value || null, name: "start" } });
                                }
                            }}
                            name="start"
                            label={i18n.t("general.from")}
                            fullWidth
                            value={data?.start || null}
                            error={false}
                            date
                            sx={styles.date}
                            allDate
                            maxDate={data?.end || undefined}
                        />

                        <InputForm
                            color="secondary"
                            clear
                            onChange={() => { }}
                            onAccept={(value) => {
                                if (value !== null && value !== data.end) {
                                    handleChange({ target: { value: value || null, name: "end" } });
                                }
                            }}
                            name="end"
                            label={i18n.t("general.to")}
                            fullWidth
                            value={data?.end || null}
                            error={false}
                            date
                            allDate
                            minDate={data?.start || undefined}
                            sx={styles.date}
                        />
                    </Box>
                </Box>
            </BaseModal>
        </Box>
    )
}